import { CaseloadSearchState, ICaseloadSearchSurface } from '../../caseload-search/CaseloadSearchState';

/**
 * The Trends tab's own caseload search. A class of its own so the container holds a second instance:
 * the Clients roster narrows itself by its search's query, and a question asked on Trends must not.
 */
export class InsightsCaseloadSearchState extends CaseloadSearchState {
    // No inject of its own: the container joins inject up the prototype chain, so restating it passes each dependency twice.
    protected readonly surface: ICaseloadSearchSurface = 'trends';
}
